type Props = {
  value: {
    command: string;
    entrypoint: string;
    env: string[];
    image: string;
    secret_env: string[];
    working_dir: string;
  };
};

export const ParamReferenceImage: React.FC<Props> = ({ value }) => {
  return <span className="text-lime-800">{value.image}</span>;
};
